import { Component, Input, OnInit } from '@angular/core';
import { ChatbotService } from "../../../services/chatbot-services/chatbot.service";
import { SharedService } from  '../../../services/shared-service/shared.service';
import { LoggerService } from 'src/services/logger-services/logger.service';
import { RegulationNextService, resolveRegulationVersion } from '../../../services/regulation-next/regulation-next.service';

@Component({
  selector: 'app-regulations-metadata',
  templateUrl: './regulations-metadata.component.html',
  styleUrls: []
})
export class RegulationsMetadataComponent implements OnInit {
  @Input() chatdata: any;
  @Input() configdata: any;
  @Input() tenantId: any;
  @Input() isDocChat: boolean = true;
  metadata: any;
  data: any;
  error: boolean = false;
  errorMessage: string = '';

  localChatData: any;
  localConfigData: any;
  loaderShow: boolean = false;
  InsightViewURL: string = "/regulations?modulePath=/Insights/view-regulation?tab=true&insid=";
  isResponseScroll: boolean = true;
  localTenantId: any;
  ShowRegulationMarketsWindow: boolean = false;
  RegulationId: string = "";
  RegulationMarkets: string = "";
  RegulationTitle: string = "";
  private readonly RegulationsMetadataComponentError = (error: any) =>
    `[RegulationsMetadataComponent] - ${JSON.stringify(error)}`;

  constructor(
    private readonly chatbotService: ChatbotService,
    private readonly sharedScrollService: SharedService,
    private readonly loggerService: LoggerService,
    private readonly regulationNextService: RegulationNextService
  ) { }

  ngOnInit(): void {
    this.localChatData = this.chatdata || {}; // Ensure localChatData is initialized
    this.localConfigData = this.configdata || {}; // Ensure localConfigData is initialized
    this.localTenantId = this.tenantId || null; // Ensure localTenantId is initialized
    this.isDocChat = this.isDocChat || true;
  }

  showLoader() {
    this.loaderShow = true;
  }

  hideLoader() {
    this.loaderShow = false;
  }
  /**
   * @param ins_id - regulation/insight ID rendered as the link label
   * @param insight - the citation item, used for numeric `version` deep-link when present
   */
  getInsightViewURLForHref(ins_id: string, insight?: unknown) {
    const baseUrl = this.configdata?.FusionAppUIUrl ?? '';
    if (!baseUrl || !ins_id) return '';
    if (this.regulationNextService.hasRegulationNextAccess()) {
      return this.regulationNextService.buildRegulationNextUrl(
        baseUrl,
        ins_id,
        resolveRegulationVersion(insight)
      );
    }
    return this.regulationNextService.buildLegacyRegulationUrl(baseUrl, ins_id);
  }

  viewFile(fileName: string, action_type: any, insight_id: any) {
    this.showLoader();
    this.isResponseScroll = false;

    this.chatbotService.ViewInsightFile(fileName, this.localTenantId, insight_id).subscribe(response => {
      if (this.configdata?.DownloadApiToggle) { // Use safe navigation
        if (!response) {
          this.loggerService.logError(this.RegulationsMetadataComponentError(response), "viewFile");
          this.hideLoader();
          return;
        }
        this.loggerService.logError(this.RegulationsMetadataComponentError(response), "viewFile");
        fetch(response)
          .then(response => {
            if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
            return response.blob();
          })
          .then(blob => {
            const blobUrl = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = blobUrl;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(blobUrl);
          })
          .catch(error => {
            this.loggerService.logError(this.RegulationsMetadataComponentError(error), "viewFile");
          })
          .finally(() => {
            this.hideLoader();
          });
      } else {
        const blobUrl = window.URL.createObjectURL(response);
        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
        this.hideLoader();
      }
    }, error => {
      this.loggerService.logError(this.RegulationsMetadataComponentError(error), "viewFile");
      this.hideLoader();
    });
  }

  DocChat(displayname: any, insight_id: any) {
    this.showLoader();
    this.isResponseScroll = false;
    this.chatbotService.GetDocChatUrl(displayname, insight_id)
      .subscribe((data: any) => {
        this.hideLoader();
        if (data.status === "200") {
          if (data.response) {
            let EncyptedFileName = data.response;
            window.open(EncyptedFileName, '_blank');
          }
        }
      });
  }

  ShowRegulationMarkets(countries: any, ins_id: string, title: string) {
    this.isResponseScroll = false;
    this.ShowRegulationMarketsWindow = true;
    this.RegulationId = ins_id;
    this.RegulationMarkets = countries?.join(', ') || ''; // Use safe navigation
    this.RegulationTitle = title;
  }

  displayCountries(countries: string[]): { firstTwo: string, remainingCount: number } {
    const countryArray = countries?.map(country => country.trim()) || []; // Use safe navigation
    const firstTwo = countryArray.slice(0, 2).join(', ');
    const remainingCount = countryArray.length - 2;
    return { firstTwo, remainingCount };
  }
}